export default "__VITE_ASSET__CwfgGnCf__"